<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  @for (buildingEquipment of buildingEquipments(); track buildingEquipment.id) {
    <nb-option
      [value]="buildingEquipment.id">{{ buildingEquipment.equipment.name }} — {{ buildingEquipment.sectionText }}
    </nb-option>
  }
</nb-select>
